/**
 * The art a story is performed on ([Stories](../../../docs/STORIES.md)).
 *
 * Twelve stages and four guests, generated from a table rather than
 * commissioned ([D-113](../../../docs/DECISIONS.md#d-113)) for the reason
 * [D-080](../../../docs/DECISIONS.md#d-080) settled for the wardrobe: a brief
 * that gates a feature on one person gates it forever, and a drawing somebody
 * can replace is worth more than a drawing nobody has made.
 *
 * Both lookups answer `undefined` rather than throwing. `sceneRef` was optional
 * for as long as there was no art, and a story still reads perfectly well
 * without it — a stage that has gone is a header that is not drawn, never a
 * lesson a child cannot open.
 */
import { GUESTS, SCENES } from './stories.generated.js';
export * from './stories.generated.js';
const SCENE_BY_ID = new Map(SCENES.map((one) => [one.id, one]));
const GUEST_BY_ID = new Map(GUESTS.map((one) => [one.id, one]));
/** The stage a `sceneRef` names, or undefined for one nobody drew. */
export const scene = (ref) => ref === null || ref === undefined ? undefined : SCENE_BY_ID.get(ref);
/**
 * A guest's portrait, or undefined.
 *
 * Sneakers is undefined here on purpose: he is not a guest, he has his own
 * drawing with a mouth the visemes drive
 * ([D-081](../../../docs/DECISIONS.md#d-081)), and the caller that draws a
 * speaker already has to know which of the two it is holding.
 */
export const guest = (id, uid) => {
    const found = GUEST_BY_ID.get(id);
    if (found === undefined)
        return undefined;
    // Two guests on one screen would otherwise share gradient ids and the second
    // would be painted in the first one's colours — the same hole, and the same
    // reason, as the avatar's ([`avatar.ts`](./avatar.ts)).
    return { ...found, body: found.body.replaceAll('{U}', uid) };
};
//# sourceMappingURL=stories.js.map